import { IAppEntity } from "src/config/entities";
import React from "react";
import { ReferenceTypes } from "src/enums/ReferenceTypes";
import { ExpenseCashsService } from "src/services/documents/ExpenseCashsService";
import { ExpenseCashsDetail } from "src/components/Pages/Documents/ExpenseCashs/components/ExpenseCashsDetail";
import ExpenseCashsList from "src/components/Pages/Documents/ExpenseCashs/components/ExpenseCashsList";
import { NFLookupExpenseCashPayments } from "src/components/Shared/NewForms/NFLookupExpenseCashPayments";
import { CreateExpenseCashsDto } from "src/components/Pages/Documents/ExpenseCashs/dtos/CreateExpenseCashsDto";
import { OutgoingCashOperationTypeEnum } from "src/components/Pages/Documents/ExpenseCashs/dtos/OutgoingCashOperationTypeEnums";

export const ExpenseCashPayments: IAppEntity = {
  entityType: "document",
  title: "Expense Cash Payments",
  pluralTitle: "Expense Cash Payments",
  apiUrl: "ExpenseCashPayments",
  apiEnum: ReferenceTypes.DocumentExpenseCashPayment,
  getDetailView: (id?: string) => {
    return React.createElement(ExpenseCashsDetail, {
      id: id
    });
  },
  getDetailViewComponent: (model: any, modelUpdatedEvent: (model: any) => void) => React.createElement(React.Fragment, {}),
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(ExpenseCashsList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent
    }),

  getLookupComponent(model: any): any {
    return React.createElement(NFLookupExpenseCashPayments, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog
    });
  },
  getDataService: () => new ExpenseCashsService("ExpenseCashPayments"),
  getEmptyModel: () => {
    const model: CreateExpenseCashsDto = {
      totalAmount: 0,
      totalAmountVat: 0,
      documentDate: new Date(),
      documentNumber: "",
      operationType: OutgoingCashOperationTypeEnum.paymentToVendor,
      status: 0,
      createdDate: new Date(),
      payments:[],
    };
    return model;
  }
};